import { useHistory } from "react-router-dom";

import useLogout from "../apiHooks/useLogout";
import { ACCESS_TOKEN } from "../constants/app.constants";
import { ROUTES } from "../constants/routes.constants";
import { isLoggedInUser } from "../utils/app.utils";

const useUserOptions = () => {
  const history  = useHistory();
  const { logout } = useLogout();

  const loggedInUser = isLoggedInUser();

  const config = [
    {
      displayName: "User Profile",
      enabled: loggedInUser,
      callback: ()=> history.push(ROUTES.USER_PROFILE)
    },
    // {
    //   displayName: " Account Settings",
    //   enabled: loggedInUser,
    //   callback: ()=> history.push(ROUTES.ACCOUNT_SETTINGS)
    // },
    {
      displayName: "Sign In",
      enabled: !localStorage.getItem(ACCESS_TOKEN),
      callback: () => history.push(ROUTES.LOGIN)

    },
    {
      displayName: "Sign Out",
      enabled: !!localStorage.getItem(ACCESS_TOKEN),
      callback: () => {
        logout();
      }
    },
  ];

  return config;
};

export default useUserOptions;
